import { Button, Form, Input, Upload, message } from 'antd';
import { NewModal } from '../NewModal';
import { useNavigate } from 'react-router-dom';
import { useCompanies } from '../../hooks/useCompanies';
import { useState } from 'react';
import { useUser } from '../../hooks/useUsers';
import FormItem from 'antd/lib/form/FormItem';
import Icon from '@ant-design/icons/lib/components/Icon';
import InputMask from "react-input-mask";

export function NewCompanyModal() {
    const navigate = useNavigate();
    const handleOk = () => { };
    const [logoTemp, setLogoTemp] = useState<any>('');
    const {
      fetchRoles
    } = useUser();
    const {
      fetchCompanies,
      createCompany,
      handleModalVisible,
      isNewModalVisible,
    } = useCompanies();
    const handleCancel = () => {
      handleModalVisible(false);
    };

    return (
        <NewModal
            buttonModalText={"Abra o modal"}
            visible={isNewModalVisible}
            handleCancel={handleCancel}
            handleOk={handleOk}
            title="Nova empresa"
        >
            <Form
                onFinish={async (form) => {
                    const status = await createCompany({...form, logo: logoTemp});

                    if (status) message.success("Aprovado");
                    else message.warning("Falha");

                    handleModalVisible(false);
                    fetchCompanies(1, 'asc', 'name');
                    fetchRoles();

                    navigate('/companies/1')
                }}
            >
                <Form.Item
                    name="name"
                    label="Nome"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                >
                    <Input maxLength={50} placeholder="Nome" />
                </Form.Item>

                <Form.Item
                    name="document"
                    label="CNPJ"
                    style={{ marginBottom: "25px" }}
                    rules={[
                        { required: true, message: "Este campo é obrigatório!" },
                        {
                        validator: (_, value) => {
                            if (!value) return Promise.resolve();

                            const cnpj = value.replace(/\D/g, "");
                            if (cnpj.length !== 14) {
                            return Promise.reject("CNPJ inválido!");
                            }

                            // Validação de CNPJ (cálculo dos dígitos verificadores)
                            let tamanho = cnpj.length - 2;
                            let numeros = cnpj.substring(0, tamanho);
                            let digitos = cnpj.substring(tamanho);
                            let soma = 0;
                            let pos = tamanho - 7;
                            for (let i = tamanho; i >= 1; i--) {
                            soma += +numeros.charAt(tamanho - i) * pos--;
                            if (pos < 2) pos = 9;
                            }
                            let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                            if (resultado !== +digitos.charAt(0)) {
                            return Promise.reject("CNPJ inválido!");
                            }

                            tamanho = tamanho + 1;
                            numeros = cnpj.substring(0, tamanho);
                            soma = 0;
                            pos = tamanho - 7;
                            for (let i = tamanho; i >= 1; i--) {
                            soma += +numeros.charAt(tamanho - i) * pos--;
                            if (pos < 2) pos = 9;
                            }
                            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                            if (resultado !== +digitos.charAt(1)) {
                            return Promise.reject("CNPJ inválido!");
                            }

                            return Promise.resolve();
                        },
                        },
                    ]}
                    >
                    <InputMask mask="99.999.999/9999-99">
                        {(inputProps: any) => <Input {...inputProps} placeholder="00.000.000/0000-00" />}
                    </InputMask>
                </Form.Item>


                <Form.Item
                    name="description"
                    label="Descrição"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                >
                    <Input maxLength={100} placeholder="Descrição" />
                </Form.Item>

                <Form.Item
                    name="primary_color"
                    label="Cor primaria"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                    initialValue="#252525"
                >
                    <Input type="color" placeholder="Cor primaria" defaultValue="#252525" />
                </Form.Item>

                <Form.Item
                    name="secondary_color"
                    label="Cor secundaria"
                    style={{
                        marginBottom: "25px",
                    }}
                    rules={[
                        {
                            required: true,
                            message: "Este campo é obrigatório!",
                        },
                    ]}
                    initialValue="#FFFFFF"
                >
                    <Input type="color" placeholder="Cor secundaria" defaultValue="#FFFFFF" />
                </Form.Item>

                <Form.Item
                    name="logo"
                    label="Logo"
                    style={{
                      marginBottom: "25px",
                    }}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Este campo é obrigatório!",
                    //   },
                    // ]}
                >
                  <Upload
                      accept=".jpg, .jpeg, .png"
                      showUploadList={false}
                      beforeUpload={file => {
                          const reader = new FileReader();

                          reader.onload = e => {
                              console.log(e?.target?.result);
                              setLogoTemp(e?.target?.result);
                          };
                          reader.readAsDataURL(file);

                          // Prevent upload
                          return false;
                      }}
                  >
                    {
                      logoTemp && <img src={logoTemp} alt="logo" style={{ width: '100px' }} />
                    }
                    <Button style={{ marginLeft: '10px' }}>
                      <Icon type="upload" /> Selecionar imagem
                    </Button>
                  </Upload>
                </Form.Item>

                <FormItem style={{ paddingLeft: "63%" }}>
                    <Button type="primary" htmlType="submit">
                        Salvar
                    </Button>
                    <Button onClick={() => handleModalVisible(false)}>Cancelar</Button>
                </FormItem>
            </Form>
        </NewModal>

    );

}
